import { init as initApi, update as updateApi } from "../../service/EvaluationCategoryService";
//アクションタイプ定義
export const INIT_SUCCESS = "EVALUATION_CATEGORY_INIT_SUCCESS";
export const INIT_FAIL = "EVALUATION_CATEGORY_INIT_FAIL";
export const UPDATE_SUCCESS = "EVALUATION_CATEGORY_UPDATE_SUCCESS";
export const UPDATE_FAIL = "EVALUATION_CATEGORY_UPDATE_FAIL";
export const CHANGE_LIST = "EVALUATION_CATEGORY_CHANGE_LIST";

export const init = () => dispatch => {
  initApi().then(response => {
    if (response.message !== null) {
      dispatch({ type: INIT_FAIL, payload: { message: response.message, messageCode: response.messageCode } });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    }
    const { abolitionFlgText, abolitionFlgValue, evaluationList, evaluationCategory } = response;
    const [abolitionFlgValueFalse, abolitionFlgValueTrue] = abolitionFlgValue;

    const age = evaluationList[0].listId;
    const categories = evaluationCategory;

    const selectList = evaluationList.map(item => ({
      value: item.listId,
      text: item.listName
    }));

    const rows = evaluationCategory
      .filter(category => category.listId === evaluationList[0].listId)
      .map((category, index) => ({
        id: index,
        categoryId: category.categoryId,
        categoryName: category.categoryName,
        abolition: category.abolitionFlg === "true" ? abolitionFlgValueTrue : abolitionFlgValueFalse,
        registeredDate: category.createdDate,
        updatedDate: category.updatedDate
      }));
    dispatch({
      type: INIT_SUCCESS,
      payload: {
        data: response,
        rows: rows,
        categories: categories,
        abolitionFlgText: abolitionFlgText,
        abolitionFlgValue: abolitionFlgValue,
        list: selectList,
        age: age
      }
    });
  });
};
export const update = rows => (dispatch, getState) => {
  const params = [];
  rows.forEach(data => {
    const param = {
      categoryId: data.categoryId,
      categoryName: data.categoryName,
      listId: getState().evaluationCategory.age,
      abolition: data.abolition,
      registeredDate: data.registeredDate,
      updatedDate: data.updatedDate
    };
    params.push(param);
  });
  updateApi(params)
    .then(() => {
      dispatch({
        type: UPDATE_SUCCESS,
        payload: {
          params: params
        }
      });
      alert("評価カテゴリを更新しました。");
    })
    .catch(error => {
      dispatch({ type: UPDATE_FAIL, payload: { message: "評価カテゴリ更新失敗", error: error } });
    });
};

export const changeList = data => dispatch => {
  const { categories, listId, abolitionFlgValue } = data;
  const [abolitionFlgValueFalse, abolitionFlgValueTrue] = abolitionFlgValue;
  const filteredCategories = categories.filter(category => category.listId === listId);
  const rows = filteredCategories.map((category, index) => ({
    id: index,
    categoryId: category.categoryId,
    categoryName: category.categoryName,
    abolition: category.abolitionFlg === "true" ? abolitionFlgValueTrue : abolitionFlgValueFalse,
    registeredDate: category.createdDate,
    updatedDate: category.updatedDate
  }));
  dispatch({ type: CHANGE_LIST, payload: { rows: rows, age: listId } });
};
